import React, { useState, useEffect, useCallback } from "react";
import "./home.css";
import Model from "../../layouts/model";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import "reactjs-popup/dist/index.css";
import { useDispatch } from "react-redux";
import axios from "axios";
import { setMeshData } from "../../redux/actions/meshdata-action";
import { setHotspotData } from "../../redux/actions/hotspotdata-action";
import { setLayoutMap } from "../../redux/actions/layout-map-action";
import { setCustomConfigData } from "../../redux/actions/custom-config-data-action";
import { setHotspotStatus } from "../../redux/actions/hotspot-action";
import { setConfigColorData } from "../../redux/actions/config-color-action";
import NotFound from "../../screens/notFound";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import Loader from "../../components/loader";
import Components from "../../screens/components";
import { BaseUrl } from "../../config.js";
import ComponentLoader from "../../components/componentLoader";
import CartWarning from "../../layouts/l002/components/addCartWarning";

const LayoutData = {
  content: {
    body: [
      { id: 1, layout: "L000" },
      { id: 2, layout: "L001A" },
      { id: 3, layout: "L002A" },
      { id: 4, layout: "L002B" },
      { id: 5, layout: "L003" },
      { id: 6, layout: "L012A" },
      { id: 7, layout: "L012B" },
      { id: 8, layout: "L012C" },
      { id: 9, layout: "L011" },
      { id: 10, layout: "L004" },
    ],
  },
};

function Home() {
  const [fullScreen, setFullScreen] = useState(false);
  const [expand, setExpand] = useState(false);
  const [iPhone, setIPhone] = useState(false);
  const [threeD, setThreeD] = useState(false);
  const [layoutData, setLayoutData] = useState(false);
  const [layoutId, setLayoutId] = useState("");
  const [layoutIndex, setLayoutIndex] = useState(0);
  const [userAuth, setUserAuth] = useState("signin");
  const [token, setToken] = useState("");
  const [resetConfig, setResetConfig] = useState(false);
  const [configLoading, setConfigLoading] = useState(false);
  const [onResetStatus, setOnResetStatus] = useState(false);
  const [cartWarningModal, setCartWarningModal] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const { route } = useParams();
  const routePath = route;
  const userData = useSelector((state) => state.userData.data);
  const dispatch = useDispatch();

  const layoutUrl = BaseUrl() + "Layout.json";

  // useEffect(() => {
  //   const expirationTimer = setTimeout(() => {
  //     sessionStorage.setItem("token", JSON.stringify(""));
  //     sessionStorage.setItem("userDetails", JSON.stringify(""));
  //   }, 3 * 60 * 1000);
  //   return () => clearTimeout(expirationTimer);
  // }, []);

  useEffect(() => {
    // console.log("userData HOME>>>>", userData?.Token);
    setToken(userData?.Token);
  }, [userData, userAuth, layoutIndex]);

  // useEffect(() => {
  //   const tokenId = JSON.parse(sessionStorage.getItem("token"));
  //   setToken(tokenId);
  // }, [userAuth, layoutIndex]);

  useEffect(() => {
    try {
      setConfigLoading(true);
      axios.get(layoutUrl).then((response) => {
        setLayoutData(response);

        const layout_Id = response?.data?.layoutMap?.find(
          (item) => item.pId === routePath
        )?.lId[layoutIndex];

        setLayoutId(layout_Id);
        setConfigLoading(false);
      });

      let os = navigator.userAgent;
      if (os.search("iPhone") !== -1) {
        setIPhone(true);
      } else {
        setIPhone(false);
      }
    } catch (error) {
    } finally {
    }
  }, [layoutIndex]);

  useEffect(() => {
    // call Mesh Data API

    if (layoutId) {
      dispatch(setHotspotStatus(false));
      dispatch(setLayoutMap(layoutData?.data?.layoutMap));
      layoutData?.data?.layouts?.filter((item) => {
        if (layoutId === item?.lId) {
          let colorName = "";
          let colorCode = "";
          let colorPrice = "";

          const colorArr = JSON.parse(JSON.stringify([item]));

          try {
            setConfigLoading(true);

            if (colorArr[0]?.color?.length > 0) {
              let colorUrl = BaseUrl() + routePath + "/" + colorArr[0]?.color;
              axios
                .get(colorUrl)
                .then((result) => {
                  if (result?.status === 200) {
                    result?.data?.map((element, index) =>
                      index === 0
                        ? (element.status = true)
                        : (element.status = false)
                    );

                    colorArr[0].color = result?.data;
                    dispatch(setMeshData(colorArr));

                    colorName = result?.data[0]?.name;
                    colorCode = result?.data[0]?.id.toLowerCase();
                    colorPrice = result?.data[0]?.price;

                    dispatch(setConfigColorData(result?.data));
                  }
                })
                .catch((error) => {
                  console.error("An error occurred:", error);
                });
            }

            setThreeD(item?.threeD);
            if (item?.hotspot != "") {
              onHotspot(BaseUrl() + routePath + "/" + item?.hotspot);
            } else {
              dispatch(setHotspotData(null));
            }

            if (item?.custom != "") {
              try {
                // setConfigLoading(true);
                // result?.data[0]?.status = true;

                let customUrl = BaseUrl() + routePath + "/" + item?.custom;

                axios.get(customUrl).then((responsedata) => {
                  let responseData = responsedata?.data;

                  let ExShowroomPrice = [
                    {
                      ProductName: "ExShowroom",
                      ProductId: "",
                      Quantity: 1,
                      Colour: "",
                      Price: "",
                      Type: "Exshowroom",
                    },
                    {
                      uId: "c01",
                      isColor: true,
                      ProductName: colorName,
                      ProductId: "",
                      Quantity: 1,
                      Colour: colorCode,
                      Price: parseInt(colorPrice),
                      Type: "BTO",
                    },
                  ];
                  responseData["orderDetails"] = ExShowroomPrice;

                  dispatch(setCustomConfigData(structuredClone(responseData)));

                  if (onResetStatus) {
                    onToast("Configuration Reset is Successful");
                    setOnResetStatus(false);
                  }
                  setConfigLoading(false);
                });
              } catch (error) {
                setConfigLoading(false);
              } finally {
              }
            } else {
              dispatch(setCustomConfigData(null));
              setConfigLoading(false);
            }
            //setConfigLoading(false);
          } catch (error) {
            setConfigLoading(false);
          } finally {
          }
        }
      });
    }
  }, [layoutId, resetConfig]);

  function onToast(message) {
    setCartWarningModal(!cartWarningModal);
    setToastMessage(message);
    setTimeout(() => {
      setCartWarningModal(false);
      setToastMessage("");
    }, 2000);
  }

  const onHotspot = (url) => {
    axios.get(url).then((response) => {
      dispatch(setHotspotData(response?.data));
    });
  };

  const screen1 = useFullScreenHandle();
  const reportChange = useCallback(
    (state, handle) => {
      setFullScreen(state);
      if (handle === screen1) {
      }
    },
    [screen1]
  );

  useEffect(() => {
    if (expand && !iPhone) {
      screen1.enter();
    } else {
      screen1.exit();
    }
  }, [expand]);

  return (
    <>
      {configLoading && (
        <div className="loader-tooltip-bg">
          <ComponentLoader color={"#FFE100"} />
        </div>
      )}
      <FullScreen handle={screen1} onChange={reportChange}>
        {layoutId === "" ? (
          <Loader />
        ) : layoutId === undefined ? (
          <NotFound />
        ) : (
          <>
            {cartWarningModal && (
              <div className="loader-tooltip-bg">
                <CartWarning
                  setCartWarningModal={setCartWarningModal}
                  cartWarningModal={cartWarningModal}
                  toastMessage={toastMessage}
                  setToastMessage={setToastMessage}
                  onClose={() => {
                    setCartWarningModal(false);
                    setToastMessage("");
                  }}
                />
              </div>
            )}
            {LayoutData.content.body.map((block) =>
              Components(
                block,
                layoutId,
                setLayoutIndex,
                layoutIndex,
                setExpand,
                fullScreen,
                setUserAuth,
                userAuth,
                token,
                setResetConfig,
                resetConfig,
                // configLoading,
                onResetStatus,
                setOnResetStatus
              )
            )}
          </>
        )}

        {layoutId && threeD && <Model pid={routePath} />}
      </FullScreen>
    </>
  );
}

export default Home;
